import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";

const PackagesShow = ({ match }) => {
	const {
		params: { packageID },
	} = match;
	const auth = useSelector(state => state.auth.user);
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [price, setPrice] = useState("");
	const [point, setPoint] = useState("");
	const [link, setLink] = useState("");
	const [points, setPoints] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل الباقة",
				breadcrumb: "الباقات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${packageID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.data.title);
				setPrice(response.data.data.data.price);
				setPoints(response.data.data.data.points);
				setLink(response.data.data.data.link);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleAddPoint = e => {
		e.preventDefault();
		if (point === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		points.push(point);
		setPoints(points);
		setPoint("");
	};

	const handleDeletePoint = (event, point) => {
		event.preventDefault();
		const arr = points.filter(function (item) {
			return item !== point;
		});
		setPoints(arr);
	};

	// const deletePoint = (event, point) => {
	// 	event.preventDefault();
	// 	const arr = points.filter(function (item) {
	// 		return item !== point;
	// 	});
	// 	setPoints(arr);
	// };

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		const data = {
			title,
			price,
			points,
			link,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/${packageID}`,
				{
					category_id: 7,
					admin_id: auth.data.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث السؤال بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-6">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										onChange={e => setTitle(e.target.value)}
										value={title}
									/>
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-item">
									<label htmlFor="link">الرابط</label>
									<input
										type="text"
										id="link"
										required
										onChange={e => setLink(e.target.value)}
										value={link}
										style={{ direction: "ltr", textAlign: "left" }}
									/>
								</div>
							</div>
						</div>
						<div className="form-item">
							<label htmlFor="price">السعر</label>
							<input
								type="text"
								id="price"
								required
								onChange={e => setPrice(e.target.value)}
								value={price}
							/>
						</div>
						<hr />
						<div className="form-item">
							<label htmlFor="point">اكتب المميزات</label>
							<input
								type="text"
								id="point"
								onChange={e => setPoint(e.target.value)}
								value={point}
							/>
						</div>
						<div className="form-item">
							<ul className="list-unstyled pointList">
								{points.map(point => (
									<li key={point}>
										<button onClick={e => handleDeletePoint(e, point)}>
											<i className="fas fa-trash"></i>
										</button>
										{point}
									</li>
								))}
							</ul>
						</div>
						<div className="form-item">
							<ul className="list-inline">
								<li className="list-inline-item">
									<button
										className="bt bt-success"
										style={{ marginLeft: "20px" }}
										onClick={handleAddPoint}
									>
										اضافة الميزه
									</button>
								</li>
								<li className="list-inline-item">
									<button className="bt bt-success">ارسال</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default PackagesShow;
